import type { ConversationKind, ListenMode } from '@jabberr/core';

/** Explain deliberate silence before it looks like an unavailable model. */
export function ReplyModeNotice({ kind, listenMode, projectKind }: {
  kind: ConversationKind;
  listenMode: ListenMode;
  projectKind: string | null;
}) {
  const silent = listenMode === 'silent';
  const named = listenMode === 'mentions' && kind === 'chat' && projectKind === 'team';
  if (!silent && !named) return null;
  return <div className="reply-mode-notice" role="status">
    {silent ? 'Silent is on. Messages are saved without replies. Choose Always in conversation details to get replies.'
      : 'When named is on. Type @Jabberr for a reply, or choose Always in conversation details to answer every message.'}
  </div>;
}
